/**
 * Average days per transition, from `Version` history.
 *
 * The bottleneck is SELECTED from the values (the largest) rather than computed — and it is named
 * rather than assumed. The prototype hardcodes "RFQ→Quotes is the bottleneck"; this says whatever
 * the data says, which on a thin dataset may well be something else.
 */
import { bottleneckKey } from '../../lib/analytics/aggregate'
import type { Funnel } from '../../lib/analytics/types'
import { BoardCard } from './BoardCard'
import { HBar } from './charts'

export function StageTimeBoard({
  funnel, isLoading, error,
}: {
  funnel: Funnel | undefined
  isLoading: boolean
  error: unknown
}) {
  const stageAvgDays = funnel?.stage_avg_days ?? {}
  const entries = Object.entries(stageAvgDays)
  const max = entries.reduce((m, [, v]) => Math.max(m, v), 0)
  const worst = bottleneckKey(stageAvgDays)

  return (
    <BoardCard
      title="Time in each stage"
      subtitle="Average days between recorded status changes."
      isLoading={isLoading}
      error={error}
      isEmpty={entries.length === 0}
      emptyLabel="No completed stage transitions for these enquiries yet."
    >
      <div style={{ marginTop: 12 }}>
        {entries.map(([key, days]) => (
          <HBar
            key={key}
            label={key}
            value={days}
            max={max}
            display={`${days.toFixed(1)}d`}
            tone={key === worst ? 'warn' : 'brand'}
          />
        ))}
      </div>
      {worst && (
        <div style={{ color: 'var(--muted)', fontSize: 11.5, marginTop: 8 }}>
          <b>{worst}</b> is the slowest step in this range.
        </div>
      )}
    </BoardCard>
  )
}
